/* tslint:disable */
/* eslint-disable */
/**
 * Haltian API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Group request object
 * @export
 * @interface ThingDeploymentGroupRequest
 */
export interface ThingDeploymentGroupRequest {
    /**
     * Group ID
     * @type {string}
     * @memberof ThingDeploymentGroupRequest
     */
    group_id: string;
}

export function ThingDeploymentGroupRequestFromJSON(json: any): ThingDeploymentGroupRequest {
    return ThingDeploymentGroupRequestFromJSONTyped(json, false);
}

export function ThingDeploymentGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThingDeploymentGroupRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'group_id': json['group_id'],
    };
}

export function ThingDeploymentGroupRequestToJSON(value?: ThingDeploymentGroupRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'group_id': value.group_id,
    };
}


